import React from 'react';

const InfoRow = ({ label, value, className = 'mb-2' }) => (
  <div className={className}>
    <h5 className="fs-10">{label}</h5>

    <div className="fs-10" style={{ whiteSpace: 'pre-line' }}>
      {value || '-'}
    </div>
  </div>
);

export default InfoRow;
